import angleDown from './angle-down.svg?raw'
import bars from './bars.svg?raw'
import globe from './globe.svg?raw'
import xmark from './xmark.svg?raw'

const icons: Record<string, string> = {
	'angle-down': angleDown,
	bars,
	globe,
	xmark,
}

class Icon extends HTMLElement {
	private svgEl: SVGSVGElement | null = null

	constructor() {
		super()
		this.attachShadow({ mode: 'open' })
	}

	connectedCallback() {
		if (this.svgEl) return

		const slottedSVG = this.querySelector('svg')
		if (slottedSVG) {
			this.renderSVG(slottedSVG.cloneNode(true) as SVGSVGElement)
		} else if (this.attributes.length > 0) {
			this.loadSVG(this.getAttribute("name") || this.getAttributeNames()[0])
		}
	}

	private renderSVG(svg: SVGSVGElement) {
		svg.setAttribute('fill', 'currentColor')
		svg.style.width = '1em'
		svg.style.height = '1em'
		svg.style.verticalAlign = '-0.125em'
		this.shadowRoot!.innerHTML = ''
		this.shadowRoot!.appendChild(svg)
		this.svgEl = svg
	}

	private async loadSVG(icon: string) {
		icon = icon.toLowerCase().replace("icon-", "")
		try {
			let text = icons[icon]
			if (!text) {
				const response = await fetch(`/static/Icons/${icon}.svg`)
				if (!response.ok) throw new Error(`Failed to load SVG: ${response.statusText}`)
				text = await response.text()
			}

			const parser = new DOMParser()
			const doc = parser.parseFromString(text, 'image/svg+xml')
			const svg = doc.querySelector('svg')
			svg?.childNodes[0]?.remove()

			if (svg) {
				this.renderSVG(svg)
			} else {
				this.shadowRoot!.innerHTML = icon
			}
		} catch (error) {
			console.error('Error loading SVG:', error)
			this.shadowRoot!.innerHTML = '<!-- SVG Load Error -->'
		}
	}
}

customElements.define('lindberg-icon', Icon)